import React, { useEffect, useState } from 'react';
import styles from './keycianecruz.module.scss';
import perfil from './src/perfil.png';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import TiktokIcon from '../../icons/tiktokIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';

const EMAIL = 'keycianecruz.pro@gmail.com';
const WHATSAPP_NUMBER = '5521975320578';
const WHATSAPP_MSG = 'Olá! Vim pelo link na bio e gostaria de mais informações.';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MSG)}`;
const INSTAGRAM_URL =
    'https://www.instagram.com/keycianecruz?stkn=MWZyZ3U2ZjlnZ2E4ZQ%3D%3D&utm_source=qr';
const TIKTOK_URL = 'https://www.tiktok.com/@keycianecruz?_r=1&_t=ZS-9AGBeJTaYyr';
const SHOPEE_URL = 'https://br.shp.ee/ks70irwm?fromSource=copy_link&smtt=0.0.9';
const ICON_COLOR = '#621927';

type EmailCard = {
    id: number;
    image: string;
    alt: string;
    modal: 'email';
};

type LinkCard = {
    id: number;
    image: string;
    alt: string;
    link: string;
    modal?: false;
};

type CardItem = EmailCard | LinkCard;

const cardImages: CardItem[] = [
    {
        id: 1,
        image: require('./src/cards/1.png'),
        alt: 'TikTok',
        link: TIKTOK_URL,
    },
    {
        id: 2,
        image: require('./src/cards/2.png'),
        alt: 'Instagram',
        link: INSTAGRAM_URL,
    },
    {
        id: 3,
        image: require('./src/cards/3.png'),
        alt: 'Shopee',
        link: SHOPEE_URL,
    },
    {
        id: 4,
        image: require('./src/cards/4.png'),
        alt: 'E-mail',
        modal: 'email',
    },
];

const Keycianecruz: React.FC = () => {
    const [emailOpen, setEmailOpen] = useState(false);

    useEffect(() => {
        if (!emailOpen) return;

        const onKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') setEmailOpen(false);
        };

        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        window.addEventListener('keydown', onKeyDown);

        return () => {
            document.body.style.overflow = prevOverflow;
            window.removeEventListener('keydown', onKeyDown);
        };
    }, [emailOpen]);

    return (
        <div className={styles.keycianecruz}>
            <div className={styles.container}>
                <img src={perfil} alt="Keyciane Cruz" className={styles.perfil} />
                <div className={styles.socialRow}>
                    <a href={`mailto:${EMAIL}`} className={styles.socialLink} aria-label="E-mail">
                        <svg
                            height="24"
                            width="24"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                        >
                            <path
                                fill={ICON_COLOR}
                                d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5L4 8V6l8 5 8-5v2z"
                            />
                        </svg>
                    </a>
                    <a
                        href={INSTAGRAM_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.socialLink}
                        aria-label="Instagram"
                    >
                        <InstagramIcon height="22" color={ICON_COLOR} />
                    </a>
                    <a
                        href={TIKTOK_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.socialLink}
                        aria-label="TikTok"
                    >
                        <TiktokIcon height="22" color={ICON_COLOR} />
                    </a>
                </div>
                <div className={styles.cards}>
                    {cardImages.map((card) =>
                        card.modal ? (
                            <button
                                type="button"
                                key={card.id}
                                className={styles.card}
                                onClick={() => setEmailOpen(true)}
                                aria-label="Abrir e-mail"
                            >
                                <img src={card.image} alt={card.alt} />
                            </button>
                        ) : (
                            <a
                                href={card.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                key={card.id}
                                className={styles.card}
                            >
                                <img src={card.image} alt={card.alt} />
                            </a>
                        )
                    )}
                </div>
            </div>

            {emailOpen ? (
                <div
                    className={styles.modalOverlay}
                    onClick={() => setEmailOpen(false)}
                    role="presentation"
                >
                    <div
                        className={styles.modal}
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="keycianecruz-modal-title"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            type="button"
                            className={styles.modalClose}
                            onClick={() => setEmailOpen(false)}
                            aria-label="Fechar"
                        >
                            ×
                        </button>
                        <p className={styles.modalEyebrow}>Contato</p>
                        <h2 id="keycianecruz-modal-title" className={styles.modalBrand}>
                            Contato
                        </h2>
                        <div className={styles.contactActions}>
                            <a href={`mailto:${EMAIL}`} className={styles.contactBtnEmail}>
                                <svg
                                    height="22"
                                    width="22"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                    aria-hidden="true"
                                >
                                    <path
                                        fill="currentColor"
                                        d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5L4 8V6l8 5 8-5v2z"
                                    />
                                </svg>
                                <span>Enviar e-mail</span>
                            </a>
                            <a
                                href={WHATSAPP_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={styles.contactBtnWhatsapp}
                            >
                                <WhatsappIcon height="22" color="currentColor" />
                                <span>WhatsApp</span>
                            </a>
                        </div>
                    </div>
                </div>
            ) : null}
        </div>
    );
};

export default Keycianecruz;
